import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CheckForUpdateService } from '@shared/services';

@Component({
  selector: 'moxi-ui-page-footer',
  imports: [TranslatePipe],
  templateUrl: './page-footer.component.html',
  styleUrl: './page-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageFooterComponent {
  private readonly updateService = inject(CheckForUpdateService);

  currentYear = new Date().getFullYear();

  version = computed(() => this.updateService.version());
}
